import { Snackbar, Alert, Slide } from '@mui/material'

function SlideTransition(props) {
    return <Slide {...props} direction="down" />
}

export function Snack({ message, setMessage, error, setError, variant = '' }) {
    return (
        <>
            {/* Snackbar per i messaggi di successo */}
            <Snackbar
                open={!!message}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                TransitionComponent={SlideTransition}
                onClose={(_, reason) => {
                    if (reason === 'clickaway') return
                    setMessage('')
                }}
            >
                <Alert
                    variant={variant || 'filled'}
                    severity="success"
                    sx={{ width: '100%' }}
                    onClose={() => setMessage('')}
                >
                    {message}
                </Alert>
            </Snackbar>

            {/* Snackbar per gli errori */}
            <Snackbar
                open={!!error}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                TransitionComponent={SlideTransition}
                onClose={(_, reason) => {
                    if (reason === 'clickaway') return
                    setError?.('')
                }}
            >
                <Alert
                    variant={variant || 'filled'}
                    severity="error"
                    sx={{ width: '100%' }}
                    onClose={() => setError?.('')}
                >
                    {error}
                </Alert>
            </Snackbar>
        </>
    )
}
